import gql from 'graphql-tag';

export const VaAuthQuery = gql`
    query chatbotAuthorizationCode($chatbotAuthInput: ChatbotAuthInput) {
        chatbotAuthorizationCode(chatbotAuthInput: $chatbotAuthInput)
    }
`;
